export default {
    me: {
        __typename: 'MeMutation',
        dietSetReplaceMeal: {
            code: 200,
            __typename: 'BasicMutationSuccess',
        },
    },
};
